module.exports = __webpack_public_path__ + "media/images/pattern-icon-9826462e816df1bc6d63199c253be0b0.png";